import {
    FirstResponderStatus,
    FirstResponderStatusDefaultMessagesEnum,
    MedicalProfessionalStatus,
    MedicalProfessionalStatusDefaultMessagesEnum,
    MilitaryStatus,
    MilitaryStatusDefaultMessagesEnum,
} from '@sheerid/jslib';
import { InjectedIntl } from 'react-intl';

export const getStatusLabel = (
    intl: InjectedIntl,
    status: FirstResponderStatus | MilitaryStatus | MedicalProfessionalStatus | undefined,
    defaultMessages:
      | typeof MilitaryStatusDefaultMessagesEnum
      | typeof FirstResponderStatusDefaultMessagesEnum
      | typeof MedicalProfessionalStatusDefaultMessagesEnum,
): string => {
    if (!status) {
        return '';
    }
    // @ts-expect-error
    return intl.formatMessage({ id: status, defaultMessage: defaultMessages[status] });
};
